module.exports = __webpack_public_path__ + "img/breakdown-yellow.f641642f.svg";